import Currency, { IConstructorCurrency } from "@core/currencies/Currency";
import { FiatCurrency } from "@core/fiat/FiatCurrency";
import { Networks } from "@core/network/Networks";
import { ProviderType } from "@custom-types/ProviderType";
import Constants from "expo-constants";
import { isCurrencyEnabled } from "@core/utils/CurrencyEnabled";
import BTCImplementation from "../blockchains/btc/BTCImplementation";

export default class BTC extends Currency {
    constructor(parameters: IConstructorCurrency) {
        super({
            name: "BTC",
            symbol: "BTC",
            fullName: "Bitcoin",
            decimals: 8,
            implementation: BTCImplementation,
            networkID: parameters.testnet ? 1 : 0,
            color: "#fd9c3f",
            icon: "bitcoin",
            seed: parameters.seed,
            fiatCurrency: parameters.fiatCurrency,
            testnet: parameters.testnet,
            network: parameters.testnet ? Networks.bitcoin.testnet : Networks.bitcoin.mainnet,
            blockchain: "bitcoin",
            account: parameters.account,
            change: parameters.change,
            index: parameters.index,
            enabled: isCurrencyEnabled(parameters.enabled, "BTC", true),
           
        });
    }

    getAddress(options?: { path?: string; format?: string }) {
        if (options && options.format == "SEGWIT") {
            options.path = options.path || this.getCurrentPath("84");
        }
        return super.getAddress(options);
    }
}
